import GeoJsonFetchLayer from './GeoJsonFetchLayer';

export default class OtoczenieLayer extends GeoJsonFetchLayer {
    static ID = 'otoczenie';
    static DESCRIPTION = 'Otoczenie z Bazy obiektów topograficznych';
    static MIN_ZOOM = 15;

    buildUrl() {
        var baseParams = {
            bbox: this.config.getCurrentBbox(),
            zoom: this.config.getCurrentZoom(),
        };

        if (typeof this.config.getFilterQueryString === 'function') {
            return this.config.baseUrl + 'api/bdot10k?' + this.config.getFilterQueryString(baseParams);
        }

        return this.config.baseUrl + 'api/bdot10k?bbox=' + this.config.getCurrentBbox()
            + '&zoom=' + this.config.getCurrentZoom();
    }

    renderData(data) {
        return this.config.renderData(data, this);
    }
}
